var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[!_vm.isDesktopApp ? 'my-5' : '', 'hotelplusflight booking']},[_c('div',{staticClass:"px-0"},[_c('div',{class:[
          'filter-cont',
          _vm.hotels.length && !_vm.isDesktopApp ? 'col-md-9' : 'col-md-12',
          !_vm.isMobileApp ? 'dVacation-pack' : 'p-0',
        ]},[_c('router-view',{on:{"setBookingStage":_vm.setBookingStage}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }